import React from 'react';
import { HeaderContainer } from './Header.style';

const Header: React.FC = () => {
  return <HeaderContainer></HeaderContainer>;
};

export default Header;
